import { takeEvery } from "@redux-saga/core/effects";
import { call, put } from "redux-saga/effects";
import { IUser } from "../../../Models/Models";
import { ILoginUserData } from "../Models/Models";
import * as actions from "../Actions/LoginActions";
import * as api from "../API/LoginApi";
import * as types from "../Types/LoginActionTypes";

export function* watchLoginSagas() {
    yield takeEvery(types.GET_LOGIN_USER_DATA, getLoginUserData);
}

export function* getLoginUserData() {
    try {
        yield put(actions.setFetchingLoginUserData(true));
        const user: IUser = yield call(() => api.getLoginUserData());
        /* Extract only feature names form userData.features to use as featureAccess */
        const newFeatureAccess = [];
        user.features.forEach(i => {
            newFeatureAccess.push(i.name);
        });
        const actionArgs: ILoginUserData = {
            firstName: user.firstName,
            lastName: user.lastName,
            initials: `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`,
            featureAccess: newFeatureAccess,
            userID: user.userID
        };
        yield put(actions.getLoginUserDataSuccess(actionArgs));
    } catch (e) {
        yield put(actions.getLoginUserDataFailure(e));
    } finally {
        yield put(actions.setFetchingLoginUserData(false));
    }
}
